// Partnership.jsx
import { useRef } from "react"
import Layout from "../../components/Layout"
import Banner from "./components/Banner"
import MindoDalamAngka from "./components/MindoDalamAngka"
import KategoriProgram from "./components/KategoriProgram"
import AlasanIkut from "./components/AlasanIkut"
import ApaKataMereka from "./components/ApaKataMereka"
import Partner from "./components/Partner"
import DiskusiDenganPakar from "./components/DiskusiDenganPakar"
import Gallery from "./components/Gallery"

const Partnership = () => {
  const pakarRef = useRef(null)

  const scrollToPakar = () => {
    pakarRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <div style={{ backgroundColor: "#F9FBFF" }}>
      <Layout idPage="partnership">
        <Banner onInfoClick={scrollToPakar} />
        <MindoDalamAngka />
        <Partner />
        <KategoriProgram onInfoClick={scrollToPakar} />
        <div ref={pakarRef}>
          <DiskusiDenganPakar />
        </div>
        <AlasanIkut />
        <ApaKataMereka />
        <Gallery />
      </Layout>
    </div>
  )
}

export default Partnership
